import React, { ImgHTMLAttributes } from 'react';

interface LogoProps
  extends Omit<
    ImgHTMLAttributes<HTMLImageElement>,
    'alt' | 'height' | 'src' | 'width'
  > {
  alt?: string;
  size: number;
}

const logoStyles = {
  display: 'block',
  objectFit: 'contain' as const,
};

const Logo = React.memo(({ alt = 'Acolyte', size, ...props }: LogoProps) => (
  <img
    {...props}
    alt={alt}
    height={size}
    src="/logo.png"
    style={logoStyles}
    width={size}
  />
));

export { Logo };
export type { LogoProps };
